var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"channelRoot",staticClass:"channel-root"},[_c('div',{staticClass:"channel-container"},_vm._l((_vm.messages),function(msg,ind){return _c('div',{key:ind},[_c('chat',{attrs:{"message":msg}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }